import React from 'react'

function GranobleAppDetails() {
    return (
        <div className="gallery-style-one-area default-padding">
            <div className="container">
                <div className="row">
                    <div className="col-xl-6 col-lg-9">
                        <div className="site-heading">
                            <h4 className="sub-title"> Granoble App</h4>
                            <h2 className="title">
                                Your Gateway to Smart Deals & IT Solutions!
                            </h2>
                        </div>
                    </div>
                    <div className="col-xl-6 col-lg-3">
                        <div className="project-navigation-items">
                            {/* Navigation */}
                            <div className="project-swiper-nav">
                                {/* Pagination */}
                                <div className="project-pagination" />
                                <div className="project-button-prev" />
                                <div className="project-button-next" />
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div className="container-fill">
                <div className="row">
                    <div className="gallery-style-one-carousel swiper">
                        {/* Additional required wrapper */}
                        <div className="swiper-wrapper">
                            {/* Single Item */}
                            <div className="swiper-slide">
                                <div className="gallery-style-one">
                                    <img src="static/img/projects/5.jpg" alt="Img Not Found" />
                                    <div className="overlay">
                                        <div className="info">
                                            <h4>
                                                IT Services
                                            </h4>
                                            <span>Trusted, Flexible</span>
                                            <p>
                                                Gain access to a broad variety of expert IT solutions, from development to cloud computing. Achieve dependable, scalable, and future-proof technology support.
                                            </p>
                                        </div>
                                        {/* <a href="project-details.html">
                        Explore <i className="fas fa-long-arrow-right" />
                      </a> */}
                                    </div>
                                </div>
                            </div>
                            {/* End Single Item */}
                            {/* Single Item */}
                            <div className="swiper-slide">
                                <div className="gallery-style-one">
                                    <img src="static/img/projects/6.jpg" alt="Img Not Found" />
                                    <div className="overlay">
                                        <div className="info">
                                            <h4>
                                                Project Track
                                            </h4>
                                            <span>Track, Manage</span>
                                            <p>
                                                Keep your projects in check with live updates and effortless tracking. Stay on top of tasks and complete projects on time.
                                            </p>
                                        </div>
                                        {/* <a href="project-details.html">
                        Explore <i className="fas fa-long-arrow-right" />
                      </a> */}
                                    </div>
                                </div>
                            </div>
                            {/* End Single Item */}
                            {/* Single Item */}
                            <div className="swiper-slide">
                                <div className="gallery-style-one">
                                    <img src="static/img/projects/7.jpg" alt="Img Not Found" />
                                    <div className="overlay">
                                        <div className="info">
                                            <h4>
                                                Promo's & Deals
                                            </h4>
                                            <span>Exclusive, Savings</span>
                                            <p>
                                                Get exclusive discounts on IT services and special promotions designed for your company. Save more and receive the best technology solutions.
                                            </p>
                                        </div>
                                        {/* <a href="project-details.html">
                        Explore <i className="fas fa-long-arrow-right" />
                      </a> */}
                                    </div>
                                </div>
                            </div>
                            {/* End Single Item */}
                            {/* Single Item */}
                            {/* <div className="swiper-slide">
                  <div className="gallery-style-one">
                    <img src="static/img/projects/8.jpg" alt="Img Not Found" />
                    <div className="overlay">
                      <div className="info">
                        <h4>
                          <a href="project-details.html">Business Analysis</a>
                        </h4>
                        <span>Network, Error</span>
                        <p>
                          Continued at up to zealously necessary breakfast. Surrounded
                          sir motionless she end literature.
                        </p>
                      </div>
                    //   <a href="project-details.html">
                    //     Explore <i className="fas fa-long-arrow-right" />
                    //   </a>
                    </div>
                  </div>
                </div> */}
                            {/* End Single Item */}
                        </div>
                    </div>
                </div>
            </div>
        </div>

    )
}

export default GranobleAppDetails
